import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {ApppView} from './components/app';
import 'bootstrap/dist/css/bootstrap.css';

(function () {
    ReactDOM.render(
        <ApppView />,
        document.getElementById('root') as HTMLElement
    );
})();